module.exports = __webpack_public_path__ + "media/images/no_image-b26162dbd1b3a06cdc3a0a00576ca349.png";